import { createAction } from "@reduxjs/toolkit";

const actionTypes = {

 	setBalances : createAction("setBalances"),	
}

export default actionTypes